import './ContactPosts.css';

export default function ContactPosts() {
  return (
    <div
      style={{
        textAlign: 'center',
        margin: '40px auto',
        color: '#005587',
        padding: '0 2rem',
      }}
    >
      <h3 style={{ marginBottom: '15px' }}>
        <strong>Comunícate hoy mismo con nosotros:</strong>
      </h3>
      <div style={{ marginBottom: '15px' }}>
        <h4>
          📞 <strong>Teléfonos</strong>
        </h4>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
          }}
          id="link-contact"
        >
          Ciudad de México:
          <a
            href="tel:+525515004000"
            style={{ marginLeft: '15px', fontWeight: 'normal' }}
          >
            55 1500 4000
          </a>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
          }}
          id="link-contact"
        >
          Guadalajara:
          <a
            href="tel:+523384211390"
            style={{ marginLeft: '15px', fontWeight: 'normal' }}
          >
            33 8421 1390
          </a>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
          }}
          id="link-contact"
        >
          Monterrey:
          <a
            href="tel:+528112532310"
            style={{ marginLeft: '15px', fontWeight: 'normal' }}
          >
            81 1253 2310
          </a>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
          }}
          id="link-contact"
        >
          Resto del país:
          <a
            href="tel:+525515004000"
            style={{ marginLeft: '15px', fontWeight: 'normal' }}
          >
            55 1500 4000
          </a>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
          }}
          id="link-contact"
        >
          Del Extranjero:
          <a
            href="tel:+525515004000"
            style={{ marginLeft: '15px', fontWeight: 'normal' }}
          >
            +52 55 1500 4000
          </a>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
          }}
          id="link-contact"
        >
          Costa Rica:
          <a
            href="tel:+50641055135"
            style={{ marginLeft: '15px', fontWeight: 'normal' }}
          >
            +506 4105 5135
          </a>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
          }}
          id="link-contact"
        >
          Guatemala:
          <a
            href="tel:+50224580828"
            style={{ marginLeft: '15px', fontWeight: 'normal' }}
          >
            +502 2458 0828
          </a>
        </div>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 'bold',
            fontSize: '20px',
          }}
          id="link-contact"
        >
          Colombia:
          <a
            href="tel:+573009114349"
            style={{ marginLeft: '15px', fontWeight: 'normal' }}
          >
            +57 30 0911 4349
          </a>
        </div>
      </div>
      <h4>
        ✉️ <strong>Correo</strong>
      </h4>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          marginBottom: '15px',
          fontWeight: 'bold',
          fontSize: '20px',
        }}
      >
        <a href="mailto:info@packsys.com">info@packsys.com</a>
      </div>
      <h5>
        <i style={{ marginRight: '10px' }} className="fab fa-whatsapp"></i>
        Envíanos un WhatsApp -{' '}
        <a href="https://api.whatsapp.com/send?phone=525515004000&text=Hola+Packsys%2C+me+gustaria+recibir+informaci%C3%B3n.">
          <strong>Click Aquí</strong>
        </a>
      </h5>
      <h4 style={{ marginBottom: '15px' }}>
        Síguenos en nuestras redes sociales:
      </h4>
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          gap: '20px',
          fontSize: '28px',
        }}
      >
        <a
          href="http://www.facebook.com/packsys"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#005587',
            textDecoration: 'none',
            transition: '0.3s',
          }}
        >
          <i className="fab fa-facebook"></i>
        </a>
        <a
          href="https://www.instagram.com/infopacksys/?hl=es-la"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#005587',
            textDecoration: 'none',
            transition: '0.3s',
          }}
        >
          <i className="fab fa-instagram"></i>
        </a>
        <a
          href="https://www.tiktok.com/@packsys"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#005587',
            textDecoration: 'none',
            transition: '0.3s',
          }}
        >
          <i className="fab fa-tiktok"></i>
        </a>
        <a
          href="https://www.youtube.com/user/infopacksys"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#005587',
            textDecoration: 'none',
            transition: '0.3s',
          }}
        >
          <i className="fab fa-youtube"></i>
        </a>
        <a
          href="https://mx.linkedin.com/company/packsys"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: '#005587',
            textDecoration: 'none',
            transition: '0.3s',
          }}
        >
          <i className="fab fa-linkedin"></i>
        </a>
      </div>
    </div>
  );
}
